const LOG_SHOW_DT = false

function dateFromTimestamp(timestamp) {
  return new Date(timestamp * 1000)
}

export const diffMinutes = (timestamp) => {
  const dt1 = new Date()
  const dt2 = dateFromTimestamp(timestamp)
  let diff = (dt2.getTime() - dt1.getTime()) / 1000
  diff = Math.round(diff / 60)

  return diff
}

function getDifferenceInSeconds(date) {
  const now = new Date().getTime()
  return (date.getTime() - now) / 1000
}

const LESS_THAN_HALF_MINUTE = 30 - 0.0001

// This function calculates a moment when "ETA value in minutes" is going to change the next time and returns milliseconds
// until that moment.
// It operates under the assumption that "ETA value in minutes" is being rounded by a default mathematical function:
//   >=2.5 is being rounded to 3
//   <2.5 is being rounded to 2
//   function finds the moment when ">=" will shift into "<".
//
export function getTimeUntilNextChangeMs(
  timestamp,
  minimumTrackedMinutes,
  defaultUpdateInterval,
) {
  if (!Number.isInteger(minimumTrackedMinutes)) {
    throw '`minimumTrackedMinutes` should be an integer'
  }

  const etaDate = dateFromTimestamp(timestamp)
  const diffInSeconds = getDifferenceInSeconds(etaDate)

  if (diffInSeconds <= 0) {
    return defaultUpdateInterval
  }

  if (diffInSeconds < minimumTrackedMinutes * 60 + LESS_THAN_HALF_MINUTE) {
    return defaultUpdateInterval
  }

  const secondsUntilNextMinute = diffInSeconds % 60

  if (secondsUntilNextMinute > LESS_THAN_HALF_MINUTE) {
    return (secondsUntilNextMinute - LESS_THAN_HALF_MINUTE) * 1000
  } else {
    return (secondsUntilNextMinute + (60 - LESS_THAN_HALF_MINUTE)) * 1000
  }
}

export const getCurrentTime = () => {
  var currentdate = new Date()
  var dt =
    currentdate.getDate() +
    '/' +
    (currentdate.getMonth() + 1) +
    '/' +
    currentdate.getFullYear() +
    ' @ ' +
    currentdate.getHours() +
    ':' +
    currentdate.getMinutes() +
    ':' +
    currentdate.getSeconds()

  return dt
}

export function makeLog() {
  console.log(
    'makeLog',
    LOG_SHOW_DT ? '[' + getCurrentTime() + ']: ' : '',
    ...arguments,
  )
}

export const isDemo = () => window.location.href.search('demo') >= 0

export function getEventMessageByType(event, type) {
  const rawData = event.data

  let data = null

  try {
    if (typeof rawData === 'string') {
      data = JSON.parse(rawData)
    } else {
      data = rawData
    }

    if (data?.type === type) return data.data

    return null
  } catch (error) {
    console.log(error)
  }

  return null
}

export const getBaseUrl = (orderId, customBaseUrl) => {
  if (customBaseUrl && typeof customBaseUrl === 'string')
    return `${customBaseUrl}/tracking-app-api/v1`

  const firstLetter = orderId[0]

  switch (firstLetter) {
    case 'p':
      return 'https://api-pp.captain.ai/tracking-app-api/v1'
    case 'u':
      return 'https://api.captain.zone/tracking-app-api/v1'
    case 'a':
    default:
      return 'https://api.captain.ai/tracking-app-api/v1'
  }
}
